var $2d999353ca652e34$exports = {};
$2d999353ca652e34$exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};


export {$2d999353ca652e34$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
